var map = {
	"./628767df0207dd78ab6e7d7b.svg": "17b7",
	"./bin.svg": "8a32",
	"./copy.svg": "87d1",
	"./green_check.svg": "e154",
	"./loyalty-by-sable.svg": "a789",
	"./market.svg": "d979",
	"./qr_not_active1.svg": "923e",
	"./qr_not_active2.svg": "b73a",
	"./qr_not_arrow.svg": "00b48",
	"./qr_scan_wrong.svg": "609d",
	"./sable-gray.svg": "a3d4",
	"./sable-loading.svg": "1c2d",
	"./sable-orange.svg": "1a80",
	"./sable_default.svg": "64bf",
	"./sable_login.svg": "0e9f",
	"./sable_logo.svg": "b2b3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";